export var createMuiListItemSecondaryActionOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            color: palette.text.secondary,
            right: spacing(2),
            "[class*='MuiListItem-alignItemsFlexStart'] + &, [class*='MuiListItem-alignItemsFlexStart'] &": {
                transform: "none",
                top: spacing(2),
            },
        },
    });
};
//# sourceMappingURL=MuiListItemSecondaryAction.js.map